import React from 'react';

const ProductGrid = ({ products, columns = 5 }) => {
  const gridCols = {
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5',
    6: 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6'
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-6 md:gap-8`}>
      {products.map((product) => (
        <div 
          key={product.id} 
          className="flex flex-col items-center group cursor-pointer"
        >
          <div className="w-full aspect-square mb-4 overflow-hidden rounded-lg transition-transform duration-300 group-hover:scale-105">
            <img 
              src={product.image} 
              alt={product.name}
              className="w-full h-full object-contain"
            />
          </div>
          <h3 className="text-center text-[#3b7ba8] font-bold text-sm md:text-base uppercase">
            {product.name}
          </h3>
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
